import styled from "styled-components";
import heroImg from "../assets/images/banner.webp";
import logo from "../assets/images/summit-logo.webp";
import { useState, useEffect } from "react";

import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

const HeroSection = () => {
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState(""); // "register" | "nominate"

  useEffect(() => {
    if (!showForm) return;

    // REGISTER FORM (iframe embed)
    if (formType === "register") {
      if (!document.getElementById("hubspot-iframe-script")) {
        const script = document.createElement("script");
        script.src = "https://js-na2.hsforms.net/forms/embed/46890133.js";
        script.defer = true;
        script.id = "hubspot-iframe-script";
        document.body.appendChild(script);
      }
    }

    // NOMINATE FORM (v2 API)
    if (formType === "nominate") {
      const loadForm = () => {
        if (window.hbspt) {
          const container = document.getElementById("hubspot-form-container");
          if (container) container.innerHTML = "";

          window.hbspt.forms.create({
            region: "na2",
            portalId: "46890133",
            formId: "425f93b6-55f2-4ad3-9471-590c5cccc06f",
            target: "#hubspot-form-container",
          });
        }
      };

      if (window.hbspt) {
        loadForm();
      } else {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/embed/v2.js";
        script.async = true;
        script.onload = loadForm;
        document.body.appendChild(script);
      }
    }
  }, [showForm, formType]);

  return (
    <Wrapper id="home">
      <Overlay />

      <Content>
        <Logo src={logo} alt="logo" />

        {/* <Title>IIT Madras Technology Summit & Awards 2026</Title>
        <SubTitle>From IITM. For Bharat. Building Together</SubTitle> */}

        <InfoRow>
          <InfoItem>
            <FaCalendarAlt />
            <span style={{ color: "#ffffff" }}>Tuesday 5th May 2026</span>
          </InfoItem>

          <InfoItem
            as="a"
            href="https://www.google.com/maps?q=28.61974830991381,77.2410528313658"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <FaMapMarkerAlt />
            <span style={{ color: "#ffffff" }}>
              Leaders Lounge, Gate 7, Bharat Mandapam, New Delhi
            </span>
          </InfoItem>
        </InfoRow>

        <Buttons>
          {/* <SecondaryBtn
            onClick={() => {
              setFormType("register");
              setShowForm(true);
            }}
          >
            Register for the Summit
          </SecondaryBtn> */}

          {/* <SecondaryBtn
            onClick={() => {
              // LinkedIn conversion tracking
              if (window.lintrk) {
                window.lintrk('track', { conversion_id: 24571372 });
              }

              setFormType("nominate");
              setShowForm(true);
            }}
          >
            Nominate for Social Impact Awards
          </SecondaryBtn> */}
        </Buttons>
      </Content>
      {showForm && (
        <ModalOverlay onClick={() => setShowForm(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseBtn onClick={() => setShowForm(false)}>✕</CloseBtn>

            {/* REGISTER FORM */}
            {formType === "register" && (
              <div
                className="hs-form-frame"
                data-region="na2"
                data-form-id="b67c2bd0-1361-4824-83f4-64ea65ea391f"
                data-portal-id="46890133"
              ></div>
            )}

            {/* NOMINATE FORM */}
            {formType === "nominate" && <div id="hubspot-form-container"></div>}
          </ModalContent>
        </ModalOverlay>
      )}
    </Wrapper>
  );
};

export default HeroSection;

/* ================= STYLES ================= */

const Wrapper = styled.section`
  position: relative;
  height: 70%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 70px;
  text-align: center;
  background:
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url(${heroImg}) center/cover no-repeat;

  @media (max-width: 1400px) {
    padding-top: 75px;
  }

  @media (max-width: 768px) {
    padding-top: 70px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  backdrop-filter: blur(4px);
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  color: white;
  max-width: 1200px;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 6px;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  padding: 120px 30px 100px;
  max-width: 800px;
  height: 100vh;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const ModalContent = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: white;
  overflow-y: auto;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);

  width: 45px;
  height: 45px;

  background: #d6a54f;
  color: #fff;
  border: none;
  border-radius: 50%;

  font-size: 20px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 4px 12px rgba(0,0,0,0.2);

  &:hover {
    background: #bd8a32;
    transform: translateX(-50%) scale(1.1);
  }
`;

const Logo = styled.img`
  width: 680px;
  max-width: 80%;

  @media (max-width: 768px) {
    width: 300px;
    margin-bottom: 1px;
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 6px;

  @media (max-width: 768px) {
    flex-direction: column; /* stack vertically */
    align-items: center; /* center buttons */
    gap: 2px; /* works now */
    margin-bottom: 2px;
    padding-bottom: 5px;
  }
`;

// const PrimaryBtn = styled.a`
//   padding: 14px 36px;
//   background: #d6a54f;
//   color: white;
//   font-weight: 600;
//   border-radius: 40px;
//   text-decoration: none;
//   transition: 0.3s;
//   border: 1px solid #d6a54f;

//   &:hover {
//     background: #bd8a32;
//     transform: translateY(-2px);
//   }

//   @media (max-width: 768px) {
//     padding: 6px 12px;
//     border: 1px solid #d6a54f;
//     margin-bottom: 2px;
//     font-size: 14px;
//   }
// `;

const InfoRow = styled.div`
  display: flex;
  gap: 40px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    gap: 4px;
    margin-bottom: 8px;
  }
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;

  &:hover span {
    text-decoration: underline;
  }

  svg {
    font-size: 20px;
    color: #fff;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    gap: 2px;

    svg {
      font-size: 16px;
    }
  }
`;

const SecondaryBtn = styled.button`
  padding: 14px 36px;
  border: 2px solid white;

  color: #791e1b;
  font-weight: 600;
  border-radius: 40px;
  cursor: pointer;
  transition: 0.3s;
  font-family: inherit;
  font-size: inherit;
  background: white;

  outline: none;

  &:hover {
    color: #791e1b;
    background: transparent;
  }

  @media (max-width: 768px) {
    padding: 6px 4px;
    font-size: 14px;
  }
`;
